import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const Tooltip = ({ id, ariaLabel, place = "top", ...rest }) => (
  <ReactTooltip
    id={id}
    place={place}
    className="!z-[100] !max-w-xs !rounded-md !px-3 !py-2 !text-sm !font-medium !shadow-lg !opacity-100 !bg-lz-paper !text-lz-ink-mid !border !border-lz-paper-border dark:!bg-lz-charcoal dark:!text-lz-concrete dark:!border-lz-charcoal-border"
    tabIndex={0}
    ariaLabel={ariaLabel}
    offset={14}
    positionStrategy="fixed"
    noArrow={true}
    {...rest}
  />
);

export default Tooltip;
